<template>
  <div
    class="subscription-layout anim-fade-in small-scroll-track"
    :class="[
      `game-back game-back_${gm_type}`,
      {
        'cursor-wait': globals_action === 'processing-payment',
      },
    ]"
    @scroll="handleScroll"
  >
    <div class="gameback cash"></div>
    <div class="gameback straddle_ante_cash"></div>
    <div class="gameback spins"></div>
    <div class="gameback husng"></div>
    <div class="gameback mtt"></div>
    <div class="gameback elite"></div>
    <div
      class="subcription-section f-column position-relative flex-1"
      style="z-index: 2; overflow-y: auto; overflow-x: hidden"
      :class="{
        'no-events': globals_action === 'processing-payment',
      }"
    >
      <LangMenu :onTopRight="true" />
      <div class="subcription-section_inner">
        <div class="d-flex mt-2 position-relative">
          <div
            v-if="$route.name !== 'SubscriptionPaymentConfirmation'"
            data-tst="subscription_go_back"
            class="mr-4 mt-2 nav-btn"
            @click="goBack"
          >
            <v-icon>mdi-chevron-left</v-icon> {{ $t('subscription.BACK') }}
          </div>
          <div
            v-if="
              $route.name === 'SubscriptionOverview' &&
              $route.name !== 'SubscriptionPaymentConfirmation'
            "
            class="nav-btn mt-2"
            @click="scrollToFaq"
          >
            {{ $t('subscription.FAQ') }}
          </div>
          <PaymentStepper
            v-if="!smallScreen && $route.name !== 'SubscriptionOverview'"
            class="payment-stepper"
          />
        </div>
      </div>

      <!-- TODO component this 001 -->
      <div
        v-if="!currentSub"
        class="f-column f-center mt-8"
      >
        <div class="user-message error-message">
          <v-icon
            color="#ef5350"
            class="user-message_icon"
            >mdi-alert-circle-outline</v-icon
          >
          <div class="user-message_title mt-6">
            {{ $t('subscription.ups_wrong') }}
          </div>
        </div>

        <OpenChatButton class="mt-6" />
      </div>

      <!-- <transition
        v-else
        name="slide"
        mode="out-in"
      >
        <router-view
          :ref="$route.name"
          class="mt-4 flex-1"
          :class="{
            'content-margin-top': !smallScreen && $route.name !== 'SubscriptionOverview',
          }"
        ></router-view>
      </transition> -->
      <router-view
        v-else
        v-slot="{ Component }"
      >
        <transition
          name="slide"
          mode="out-in"
        >
          <component
            :is="Component"
            :ref="$route.name"
            class="mt-4 flex-1"
            :class="{
              'content-margin-top': !smallScreen && $route.name !== 'SubscriptionOverview',
            }"
          />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<script>
import PaymentStepper from '@/components/Payments/PaymentStepper'
import { gtm_sub_subpage_action } from '@/helpers/gtm'
import { seg_setCheckoutId } from '@/helpers/segment'

import LangMenu from '@/components/LangSwitcher/LangMenu'
import links_mix from '@/mixins/links_mix'
import payment_mix from '@/mixins/payment_mix'
import GwBtn from '@/components/lib/GwBtn/GwBtn.vue'
import OpenChatButton from '@/components/Payments/OpenChatButton.vue'

// http://localhost:8080/subscription/payment-gate?gm_type=cash&gm_tier=starter&gm_interval=monthly
// http://localhost:8080/subscription/payment-confirmation?success=stripe&gm_type=cash&gm_tier=starter&gm_interval=monthly

export default {
  name: 'Subscription',
  components: {
    OpenChatButton,
    GwBtn,
    PaymentStepper,
    LangMenu,
  },
  mixins: [payment_mix, links_mix],
  beforeRouteEnter(to, from, next) {
    if (from.name) {
      gtm_sub_subpage_action({ from_path_name: from.name })
    }
    next()
  },
  data() {
    return {}
  },
  created() {
    seg_setCheckoutId()
    // this.$store.dispatch('account_settings_user_only')
    // this.$store.dispatch('payments_subscription_plan')
  },
  methods: {
    handleScroll() {
      const { SubscriptionOverview } = this.$refs
      if (SubscriptionOverview) {
        const { featuresTable } = SubscriptionOverview.$refs
        if (featuresTable) {
          featuresTable.handleScroll()
        }
      }
    },
    scrollToFaq() {
      const Faq = document.getElementById('faq')
      if (Faq) {
        Faq.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
    checkSelectedPlan(v) {
      if (!v) {
        this.$router.replace({ name: 'SubscriptionOverview', query: {} })
      }
    },
  },
  computed: {
    globals_action() {
      const { globals_action } = this.$store.getters
      return globals_action
    },
    mobile() {
      const { globals_mobile } = this.$store.getters
      return globals_mobile
    },
    smallScreen() {
      const { globals_window_size } = this.$store.getters
      return globals_window_size.width < 768
    },
  },
  watch: {
    selectedPlan: {
      immediate: true,
      handler: 'checkSelectedPlan',
    },
  },
}
</script>

<style lang="scss">
.cursor-wait {
  cursor: wait !important;
}
.subcription-section {
  width: 100vw;
  display: flex;
  flex-shrink: 0;
  &_inner {
    margin: 0 auto;
    width: 84.65rem;
    // width: 1260px;
    transition: all 0.3s ease-in-out;
    max-width: calc(100vw - 2rem);
  }
}
</style>

<style lang="scss" scoped>
@media (max-width: 1023px) {
  .plan-boxes {
    flex-direction: column;
    .plan-box {
      width: calc(100vw - 2rem) !important;
      margin: 1rem !important;
    }
  }
}

.user-message {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding: 1rem;
  &_icon {
    font-size: 6rem !important;
  }
  &_title {
    font-size: 1.5rem;
    font-weight: 700;
    max-width: 42rem;
    padding: 0 1rem;
  }
}

.content-margin-top {
  margin-top: 6rem !important;
}

.game-back {
  &:before {
    content: '';
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    z-index: 0;
    opacity: 0;
  }
  .gameback {
    opacity: 0;
    transition: 0.15s;
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 1;
  }
  --ppp: -250%;
  .cash {
    background: linear-gradient(-5deg, var(--clr-cash) var(--ppp), transparent);
  }
  &_cash {
    .affiliate-message {
      background: #00ac8d41;
    }
    .cash {
      opacity: 1;
    }
  }

  .straddle_ante_cash {
    background: linear-gradient(-5deg, var(--clr-straddle_ante_cash) var(--ppp), transparent);
  }
  &_straddle_ante_cash {
    .affiliate-message {
      background: #00ac8d41;
    }
    .straddle_ante_cash {
      opacity: 1;
    }
  }
  .spins {
    background: linear-gradient(-5deg, var(--clr-spins) var(--ppp), transparent);
  }
  &_spins {
    .affiliate-message {
      background: #a900db3d;
    }
    .spins {
      opacity: 1;
    }
  }
  .husng {
    background: linear-gradient(-5deg, var(--clr-husng) var(--ppp), transparent);
  }
  &_husng {
    .affiliate-message {
      background: #007aff3d;
    }
    .husng {
      opacity: 1;
    }
  }
  .mtt {
    background: linear-gradient(-5deg, var(--clr-mtt) var(--ppp), transparent);
  }
  &_mtt {
    .affiliate-message {
      background: rgba(0, 247, 255, 0.288);
    }
    .mtt {
      opacity: 1;
    }
  }
}

.payment-stepper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  margin: auto;
}
.nav-btn {
  opacity: 0.8;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.9;
  }
}

.title-headline {
  font-size: 2.5rem;
  font-weight: 700;
}

.subscription-layout {
  display: flex;
  width: 100%;
  height: var(--vh-100);
  overflow-x: hidden;

  background: var(--clr-subscription-back);
  flex-direction: column;
  overflow-y: auto;
}
.moved-left {
  margin-left: 20rem;
}
.plan-boxes {
  display: flex;
  // margin: 1rem 0;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  &_left {
    @extend .moved-left;
  }
  .plan-box {
    // width: 33%;
    flex: 1;
    &:nth-child(2) {
      // margin: 0 0.5rem;
      border-left: solid grey 1px;
      border-right: solid grey 1px;
    }
  }
}

.feature-list {
  opacity: 0.8;
  padding: 1rem;
  cursor: pointer;
  font-weight: 500;
  &:hover {
    opacity: 0.9;
  }
}

.starting-at {
  display: flex;
  flex-direction: column;
  margin: 1rem 0 0 0;
  .starting-at-title {
    font-size: 1.5rem;
    font-weight: 700;
    .starting-at-month {
      font-size: 1rem;
      font-weight: 400;
    }
  }
}
.refund-message {
  font-size: 1.5rem;
  font-weight: 700;
  // color: var(--clr-grey-2);
  padding: 2rem;
  text-align: center;
  height: var(--vh-100);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  // margin: 8rem 0;
  .icon-logo {
    &_icon {
      font-size: 12rem !important;
      color: var(--clr-black-1) !important;
    }
  }
}
</style>
